import angular from 'angular';
import IComplianceAppDataService from './IComplianceApp.data.service';

require('ng-file-upload');

const ngFileUpload = 'ngFileUpload';

let _upload;

class bcpDataService extends IComplianceAppDataService {
  constructor(
    $http,
    Upload,
    utilityService, // eslint-disable-line no-shadow
  ) {
    super($http, utilityService, 'bcp');
    _upload = Upload;

    /**
     * @deprecated Use the shared model service for cached calls which uses cacheManager
     */
    this.cache = {};
    console.log('app.services.bcpDataService created');
  }

  // ///////////// BCP App ///////////////////
  initApp() {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/init`,
      method: 'GET',
    });
  }

  getEcosystemNavigations(navId) {
    return this.$http({
      url: `${this.apiRootUrl}/ent/navigation/ecosystemNavigation/${navId}`,
      method: 'GET',
    });
  }

  // ///////////// Assessment ///////////////////
  getAssessments() {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment`,
      method: 'GET',
    });
  }

  getAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}`,
      method: 'GET',
    });
  }

  getAssessmentStatus(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/status`,
      method: 'GET',
    });
  }

  allowNewAssessment() {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/allowNew`,
      method: 'GET',
    });
  }

  checkAssessmentExists(name, assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/checkExists`,
      method: 'GET',
      params: {
        name,
        id: assessmentId,
      },
    });
  }

  saveAssessment(assessment) {
    if (assessment.assessmentId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/bcp/assessment/${assessment.assessmentId}`,
        method: 'PUT',
        data: this.serializeData(assessment),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment`,
      method: 'POST',
      data: this.serializeData(assessment),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  saveNotifications(assessmentId, assessmentNotifications = []) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/notification/saveList`,
      method: 'POST',
      data: JSON.stringify(assessmentNotifications),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  deleteAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}`,
      method: 'DELETE',
    });
  }

  canBoardApprove(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/canApprove`,
      method: 'GET',
    });
  }

  approveAssessment(assessmentId, approvedById, approvalDate) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/boardApproved`,
      method: 'PUT',
      data: this.serializeData({
        approvedById,
        approvalDate,
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  unapproveAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/unapprove`,
      method: 'PUT',
      data: this.serializeData({
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  auditedBy(assessmentId, auditedBy, auditDate) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/auditedBy`,
      method: 'PUT',
      data: this.serializeData({
        auditedBy,
        auditDate,
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  examinedBy(assessmentId, examinedBy, examineDate) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/examinedBy`,
      method: 'PUT',
      data: this.serializeData({
        examinedBy,
        examineDate,
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  canGenerateDocument(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/canGenerateDocument`,
      method: 'GET',
    });
  }

  canPrioritize(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/canPrioritize`,
      method: 'GET',
    });
  }

  hasIncompleteAssessment() {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/hasIncompleteAssessment`,
      method: 'GET',
    });
  }

  // ///////////// Process ////////////////////
  getBackupFrequencyOptions() {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/backupFrequencyOption`,
      method: 'GET',
    });
  }

  getProcessesByAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/process`,
      method: 'GET',
    });
  }

  getProcessesByUser(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/process/availableForUser`,
      method: 'GET',
    });
  }

  saveAssessmentProcesses(assessmentId, assessmentProcesses) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/process/saveList`,
      method: 'PUT',
      data: JSON.stringify(assessmentProcesses),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  saveAssessmentProcessThreats(assessmentId, assessmentProcesses) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/process/threats/saveList`,
      method: 'PUT',
      data: JSON.stringify(assessmentProcesses),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  getDocumentProcedureByUser(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/process/documentProcedureForUser`,
      method: 'GET',
    });
  }

  saveDocumentProcedure(assessmentId, assessmentProcesses) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/process/saveDocumentProcedureList`,
      method: 'PUT',
      data: JSON.stringify(assessmentProcesses),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  checkProcessHasBeenUpdate(assessmentProcesses) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentProcess/compareDocumentProcedureListUpdates`,
      method: 'PUT',
      data: JSON.stringify(assessmentProcesses),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  submitAssessmentProcesses(assessmentProcessIds) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentProcess/submit`,
      method: 'PUT',
      data: this.serializeData({
        assessmentProcessIds: JSON.stringify(assessmentProcessIds),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  bulkSubmitAssessmentProcesses(assessmentId, assessmentProcessIds) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/processImpactAnalysis/bulkSubmit`,
      method: 'PUT',
      data: this.serializeData({
        assessmentProcessIds: JSON.stringify(assessmentProcessIds),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  approveOrDenyProcesses(assessmentProcessApprovals) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentProcess/approve`,
      method: 'PUT',
      data: this.serializeData({
        assessmentProcessApprovals: JSON.stringify(assessmentProcessApprovals),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  bulkApproveAssessmentProcesses(assessmentId, assessmentProcessIds) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/processImpactAnalysis/bulkApprove`,
      method: 'PUT',
      data: this.serializeData({
        assessmentProcessIds: JSON.stringify(assessmentProcessIds),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  getProcessesToPrioritize(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/process/prioritize`,
      method: 'GET',
    });
  }

  savePrioritizedProcesses(prioritizedProcesses) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentProcess/prioritize`,
      method: 'PUT',
      data: this.serializeData({
        prioritizedProcesses: JSON.stringify(prioritizedProcesses),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  resetAssessmentProcessStatus(assessmentId, assessmentProcessIds) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/processImpactAnalysis/resetStatus`,
      method: 'PUT',
      data: this.serializeData({
        assessmentProcessIds: JSON.stringify(assessmentProcessIds),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  // /// Hardware and Schematics //////
  getNetwork(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/network`,
      method: 'GET',
    });
  }

  // /// Schematics //////

  getSchematics(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/schematic`,
      method: 'GET',
    });
  }

  // TODO: Where is this API controller?
  downloadSchematic(documentId) {
    return this.$http({
      url: `${this.apiRootUrl}/media/document/${documentId}`,
      method: 'GET',
      responseType: 'arraybuffer',
    });
  }

  downloadSchematicContent(documentId, customerId) {
    return this.$http({
      url: `${this.apiRootUrl}/media/document/content/${customerId}/${documentId}`,
      method: 'GET',
    });
  }

  checkSchematicExists(assessmentId, schematicId, name) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/schematic/checkExists`,
      method: 'GET',
      params: {
        assessmentSchematicId: schematicId,
        name,
      },
    });
  }

  checkSchematicFileNameExists(assessmentId, schematicId, fileName) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/schematic/checkFileNameExists`,
      method: 'GET',
      params: {
        assessmentSchematicId: schematicId,
        fileName,
      },
    });
  }

  updateSchematic(schematic) {
    /* eslint-disable */
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${schematic.assessmentId}/schematic/${schematic.assessmentSchematicId}`,
      method: 'PUT',
      data: JSON.stringify(schematic),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  uploadSchematic(assessmentId, schematic) {
    return _upload.upload({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/schematic/upload`,
      data: {
        assessmentSchematicId: schematic.assessmentSchematicId,
        schematicSectionId: schematic.schematicSectionId,
        name: schematic.name,
        file: schematic.file,
      },
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  uploadSchematics(assessmentId, schematicSectionId, files) {
    return _upload.upload({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/schematic/bulkUpload`,
      data: {
        schematicSectionId,
        files,
        echo: true,
      },
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteSchematic(assessmentSchematicId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentSchematic/${assessmentSchematicId}`,
      method: 'DELETE',
    });
  }

  deleteSchematics(idList) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentSchematic/bulkDelete`,
      method: 'PUT',
      data: JSON.stringify(idList),
      params: { echo: true },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  moveSchematicUp(assessmentSchematicId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentSchematic/moveUp`,
      method: 'PUT',
      data: this.serializeData({
        assessmentSchematicId,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  moveSchematicDown(assessmentSchematicId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentSchematic/moveDown`,
      method: 'PUT',
      data: this.serializeData({
        assessmentSchematicId,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  getSchematicSections() {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/schematicSection`,
      method: 'GET',
    });
  }

  // /// Workstations //////
  saveWorkstation(assessmentId, workstation) {
    if (workstation.assessmentWorkstationId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/bcp/assessmentWorkstation/${workstation.assessmentWorkstationId}`,
        method: 'PUT',
        data: JSON.stringify(workstation),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/json' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/workstation`,
      method: 'POST',
      data: JSON.stringify(workstation),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  getWorkstations(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/workstation`,
      method: 'GET',
    });
  }

  deleteWorkstation(assessmentWorkstationId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentWorkstation/${assessmentWorkstationId}`,
      method: 'DELETE',
    });
  }

  deleteWorkstations(idList) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentWorkstation/bulkDelete`,
      method: 'PUT',
      data: JSON.stringify(idList),
      params: { echo: true },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  deleteWorkstationByAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/workstation`,
      method: 'DELETE',
    });
  }

  getNetComplyWorkstationCount() {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentWorkstation/getNetcomplyCounts`,
      method: 'GET',
      params: {},
    });
  }

  getDattoWorkstationCount() {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentWorkstation/getDattoCounts`,
      method: 'GET',
      params: {},
    });
  }

  synchronizeWorkstationsFromNetComply(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/workstation/importNetcomply`,
      method: 'POST',
      params: {
        echo: true,
      },
    });
  }

  synchronizeWorkstationsFromDatto(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/workstation/importDatto`,
      method: 'POST',
      params: {
        echo: true,
      },
    });
  }

  // /// Servers //////
  saveServer(assessmentId, server) {
    if (server.assessmentServerId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/bcp/assessmentServer/${server.assessmentServerId}`,
        method: 'PUT',
        data: JSON.stringify(server),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/json' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/server`,
      method: 'POST',
      data: JSON.stringify(server),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  getServers(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/server`,
      method: 'GET',
    });
  }

  deleteServer(assessmentServerId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentServer/${assessmentServerId}`,
      method: 'DELETE',
    });
  }

  deleteServers(idList) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentServer/bulkDelete`,
      method: 'PUT',
      data: JSON.stringify(idList),
      params: { echo: true },
      headers: { 'Content-Type': 'application/Json' },
    });
  }

  deleteServerByAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/server/byAssessment`,
      method: 'DELETE',
    });
  }

  getNetComplyServerCount() {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentServer/getNetcomplyCounts`,
      method: 'GET',
      params: {},
    });
  }

  getDattoServerCount() {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentServer/getDattoCounts`,
      method: 'GET',
      params: {},
    });
  }

  synchronizeServersFromNetComply(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/server/importNetcomply`,
      method: 'POST',
      params: {
        echo: true,
      },
    });
  }

  synchronizeServersFromDatto(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/server/importDatto`,
      method: 'POST',
      params: {
        echo: true,
      },
    });
  }

  // //// Facilities //////
  saveFacilities(assessmentFacility) {
    const assessmentFacilityId = assessmentFacility.assessmentFacilityId;
    if (assessmentFacilityId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/bcp/assessmentFacility/${assessmentFacilityId}`,
        method: 'PUT',
        data: this.serializeData(assessmentFacility),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentFacility`,
      method: 'POST',
      data: this.serializeData(assessmentFacility),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  // //// IT/Core Procedures //////
  saveITCoreProcedures(assessmentITCoreProcedure) {
    const assessmentITCoreProcedureId = assessmentITCoreProcedure.assessmentITCoreProcedureId;
    if (assessmentITCoreProcedureId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/bcp/assessmentITCoreProcedure/${assessmentITCoreProcedureId}`,
        method: 'PUT',
        data: this.serializeData(assessmentITCoreProcedure),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentITCoreProcedure`,
      method: 'POST',
      data: this.serializeData(assessmentITCoreProcedure),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  /* *****************************************************************************
   *  Threat Assessment
   */

  /**
   * AssessmentThreatController.cs
   *
   * @typedef assessmentThreat
   * @param {int} assessmentThreatId
   * @param {int} assessmentId
   * @param {int} threatCategoryId
   * @param {int} threatTypeId
   * @param {string} threatType -- e.g., "Payment Service Providers",
   * @param {?string} threatTypeToolTipText
   * @param {string} threatImpactOption -- e.g., "Nonexistent",
   * @param {int} threatImpactOptionId
   * @param {string} threatProbabilityOption -- e.g., "Never Happens",
   * @param {int} threatProbabilityOptionId
   * @param {string} threatLevel -- e.g., "Low",
   * @param {int} threatLevelId8
   * @param {int} score
   *
   * @return {Promise<$http>}
   */
  getThreats(assessmentId) {
    return this.$http({
      // Alternate Route: "/bcp/assessmentThreat/{id}" (Get w/o id not supported)
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/threat`,
      method: 'GET',
    });
  }

  /**
   *
   * @param {Array<assessmentThreat>} assessmentThreats
   * @return {*}
   */
  saveThreats(assessmentThreats) {
    return this.$http({
      // Alternate Route: "bcp/assessment/{assessmentId}/threat/saveList"
      url: `${this.apiRootUrl}/bcp/assessmentThreat/saveList`,
      method: 'POST',
      data: JSON.stringify(assessmentThreats),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  getThreatOptions() {
    return this.$http({
      // Alternate Route: "bcp/assessment/{assessmentId}/threat/options"
      url: `${this.apiRootUrl}/bcp/assessmentThreat/options`,
      method: 'GET',
    });
  }

  /**
   * ThreatCategoryController.cs
   * Endpoint Supports: GET List, GET by Id, PUT, POST, DELETE
   */
  getThreatCategories() {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/threatCategory`,
      method: 'GET',
    });
  }

  /**
   * ThreatTypeController.cs
   * Endpoint Supports: GET List, GET by Id, PUT, POST, DELETE
   *
   * @typedef {Object} threatType
   * @param {int} threatTypeId
   * @param {int} threatCategoryId
   * @param {string} name -- e.g., "Fraud, Theft, Blackmail"
   * @param {?string} description
   * @param {int} sortOrder
   * @param {?string} toolTipText
   * @param {int} threatForewarningId
   * @param {int} threatDurationId
   * @param {int} threatSuddennessId
   *
   * @return {Promise<$http>}
   */
  getThreatTypes() {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/threatType`,
      method: 'GET',
    });
  }

  /* *****************************************************************************
   *  Authority and Management
   */

  getAuthorityAndManagement(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/teamMember/byUser`,
      method: 'GET',
    });
  }

  // //// Team and Contacts //////
  getTeamContacts(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/teamMember`,
      method: 'GET',
    });
  }

  saveTeamContacts(assessmentId, users) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/teamMember/saveList`,
      method: 'POST',
      data: this.serializeData({
        users: JSON.stringify(users),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  /* *****************************************************************************
   *  Health Resources
   */

  getHealthResources(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/healthResource`,
      method: 'GET',
    });
  }

  saveHealthResource(healthResource) {
    if (healthResource.assessmentHealthResourceId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/bcp/assessmentHealthResource/${healthResource.assessmentHealthResourceId}`,
        method: 'PUT',
        data: JSON.stringify(healthResource),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/json' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentHealthResource`,
      method: 'POST',
      data: JSON.stringify(healthResource),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  deleteHealthResource(assessmentHealthResourceId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentHealthResource/${assessmentHealthResourceId}`,
      method: 'DELETE',
    });
  }

  /* *****************************************************************************
   *  Succession Planning
   */

  getSuccessionProcesses(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/successionPlan`,
      method: 'GET',
    });
  }

  saveProcessSuccessions(assessmentProcessId, assessmentSuccessionPlans) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentProcess/${assessmentProcessId}/successionPlan/saveList`,
      method: 'POST',
      data: this.serializeData({
        successionPlans: JSON.stringify(assessmentSuccessionPlans),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  /* *****************************************************************************
   *  Vendor Resources
   */

  getVendorResources(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentVendorResource/byAssessment/${assessmentId}`,
      method: 'GET',
    });
  }

  getVendorResource(assessmentVendorResourceId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentVendorResource/${assessmentVendorResourceId}`,
      method: 'GET',
    });
  }

  saveVendorResourcesList(assessmentId, vendorResourceIds) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/vendorResource/saveList`,
      method: 'POST',
      data: this.serializeData({
        vendors: JSON.stringify(vendorResourceIds),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  addVendorResource(vendorResource) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentVendorResource`,
      method: 'POST',
      data: JSON.stringify(vendorResource),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  updateVendorResource(vendorResource) {
    const { assessmentVendorResourceId } = vendorResource;
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentVendorResource/${assessmentVendorResourceId}`,
      method: 'PUT',
      data: JSON.stringify(vendorResource),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  deleteVendorResource(assessmentVendorResourceId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentVendorResource/${assessmentVendorResourceId}`,
      method: 'DELETE',
    });
  }

  /* *****************************************************************************
   *  Other Resources
   */

  getOtherResources(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentOtherResource/byAssessment/${assessmentId}`,
      method: 'GET',
    });
  }

  getOtherResource(assessmentOtherResourceId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentOtherResource/${assessmentOtherResourceId}`,
      method: 'GET',
    });
  }

  addOtherResource(otherResource) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentOtherResource`,
      method: 'POST',
      data: JSON.stringify(otherResource),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  updateOtherResource(otherResource) {
    const { assessmentOtherResourceId } = otherResource;
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentOtherResource/${assessmentOtherResourceId}`,
      method: 'PUT',
      data: JSON.stringify(otherResource),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  deleteOtherResource(assessmentOtherResourceId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentOtherResource/${assessmentOtherResourceId}`,
      method: 'DELETE',
    });
  }

  /* *****************************************************************************
   *  Department Resources
   */

  getDepartments(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/department`,
      method: 'GET',
    });
  }

  saveDepartments(assessmentDepartments) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentDepartment/saveList`,
      method: 'POST',
      data: this.serializeData({
        assessmentDepartments: JSON.stringify(assessmentDepartments),
        echo: true,
      }),
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  // //// Custom Test Procedures //////
  getCustomTestProcedures(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentCustomTestProcedure/${assessmentId}`,
      method: 'GET',
    });
  }

  /* eslint-disable */
  saveCustomTestProcedures(customTestProcedures) {
    if (customTestProcedures.assessmentCustomTestProcedureId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/bcp/assessmentCustomTestProcedure/${customTestProcedures.assessmentCustomTestProcedureId}`,
        method: 'PUT',
        data: JSON.stringify(customTestProcedures),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/json' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentCustomTestProcedure`,
      method: 'POST',
      data: this.serializeData(customTestProcedures),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  // //// Custom Test Procedures //////
  getPandemicPlanProcedures(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/pandemicPlan`,
      method: 'GET',
    });
  }

  /* eslint-disable */
  savePandemicPlanProcedures(pandemicPlanProcedures) {
    if (pandemicPlanProcedures.assessmentPandemicPlanId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/bcp/assessmentPandemicPlan/${pandemicPlanProcedures.assessmentPandemicPlanId}`,
        method: 'PUT',
        data: JSON.stringify(pandemicPlanProcedures),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/json' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentPandemicPlan`,
      method: 'POST',
      data: this.serializeData(pandemicPlanProcedures),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  /* *****************************************************************************
   *  Succession Planning
   */

  getEmergencyPlanProcedures(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/emergencyPlan`,
      method: 'GET',
    });
  }

  saveEmergencyPlanProcedures(emergencyPlanProcedure) {
    if (emergencyPlanProcedure.assessmentEmergencyPlanId > 0) {
      return this.$http({
        url: `${this.apiRootUrl}/bcp/assessmentEmergencyPlan/${emergencyPlanProcedure.assessmentEmergencyPlanId}`,
        method: 'PUT',
        data: JSON.stringify(emergencyPlanProcedure),
        params: {
          echo: true,
        },
        headers: { 'Content-Type': 'application/json' },
      });
    }
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentEmergencyPlan`,
      method: 'POST',
      data: this.serializeData(emergencyPlanProcedure),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  // //// Test//////
  getTests(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/test`,
      method: 'GET',
    });
  }

  getTest(assessmentTestId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentTest/${assessmentTestId}`,
      method: 'GET',
    });
  }

  addTest(assessmentTest) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentTest`,
      method: 'POST',
      data: this.serializeData(assessmentTest),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  updateTest(assessmentTest) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentTest/${assessmentTest.assessmentTestId}`,
      method: 'PUT',
      data: this.serializeData(assessmentTest),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteTest(assessmentTestId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentTest/${assessmentTestId}`,
      method: 'DELETE',
    });
  }

  getTestTypes() {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/testType`,
      method: 'GET',
    });
  }

  getTestDocuments(assessmentTestId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/test/${assessmentTestId}/document`,
      method: 'GET',
    });
  }

  checkTestDocumentDisplayNameExists(assessmentTestId, assessmentTestDocumentId, displayName) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/test/${assessmentTestId}/document/checkDisplayNameExists`,
      method: 'GET',
      params: {
        assessmentTestDocumentId,
        displayName,
      },
    });
  }

  checkTestDocumentFileNameExists(assessmentTestId, assessmentTestDocumentId, fileName) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/test/${assessmentTestId}/document/checkFileNameExists`,
      method: 'GET',
      params: {
        assessmentTestDocumentId,
        fileName,
      },
    });
  }

  updateTestDocument(testDocument) {
    /* eslint-disable */
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentTestDocument/${testDocument.assessmentTestDocumentId}`,
      method: 'PUT',
      data: JSON.stringify(testDocument),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  uploadTestDocument(assessmentTestId, testDocument) {
    return _upload.upload({
      url: `${this.apiRootUrl}/bcp/assessment/test/${assessmentTestId}/document/upload`,
      data: {
        assessmentTestId,
        assessmentTestDocumentId: testDocument.assessmentTestDocumentId,
        displayValue: testDocument.displayValue,
        description: testDocument.description,
        file: testDocument.file,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  deleteTestDocument(assessmentTestDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentTestDocument/${assessmentTestDocumentId}`,
      method: 'DELETE',
    });
  }

  downloadTestTemplate() {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentTestDocument/template`,
      method: 'GET',
    });
  }

  // TODO: CONVERT ALL THESE TO NEW API
  // ///// Import //////////
  getImportTemplateFile(/* networkPath, storeRootKey, fileType, fileName */) {
    // const url = `${_paths.directories.handlers.root}BCP/${networkPath}/import/handleImportFile.ashx`;
    //
    // const $frmDownloadFile = angular.element(
    //   '<form' +
    //   ' id="frmDownloadFile"' +
    //   ' method="get"' +
    //   ' target="ifrmDownloadFile">' +
    //   '</form>'
    // ).appendTo(angular.element('#ifrmDownloadFile'));
    // $frmDownloadFile.attr(
    //   'action',
    //   url
    // );
    // $frmDownloadFile.append(angular.element(
    //   '<input' +
    //   ' type="hidden"' +
    //   ' name="storeRootKey" />'
    // ).val(storeRootKey));
    // $frmDownloadFile.append(angular.element(
    //   '<input' +
    //   ' type="hidden"' +
    //   ' name="fileType" />'
    // ).val(fileType));
    // $frmDownloadFile.append(angular.element(
    //   '<input' +
    //   ' type="hidden"' +
    //   ' name="f" />'
    // ).val(fileName));
    // $frmDownloadFile.submit();
    // _alerts.success(_copy.downloadTemplate.text);
  }

  getWorkstationImportDetails(/* workstationImportSetId */) {
    // return this.$http({
    //   url: `${_paths.directories.handlers.root}BCP/Workstations/Import/getImportDetails.ashx`,
    //   method: 'GET',
    //   params: {
    //     workstationImportSetId: workstationImportSetId,
    //   },
    // });
  }

  stageWorkstationImportData(/* customerId, assessmentId, bankName, fileName, uploadType */) {
    // return this.$http.post(
    //   `${_paths.directories.handlers.root}BCP/Workstations/Import/stageImportData.ashx`,
    //   {},
    //   {
    //     params: {
    //       customerId: customerId,
    //       assessmentId: assessmentId,
    //       bankName: bankName,
    //       fileName: fileName,
    //       uploadType: uploadType,
    //     },
    //   }
    // );
  }

  processWorkstationImportData(/* assessmentId, workstationImportSetId */) {
    // return this.$http.post(
    //   `${_paths.directories.handlers.root}BCP/Workstations/Import/processImport.ashx`,
    //   {},
    //   {
    //     params: {
    //       assessmentId: assessmentId,
    //       workstationImportSetId: workstationImportSetId,
    //     },
    //   }
    // );
  }

  getServerImportDetails(/* serverImportSetId */) {
    // return this.$http({
    //   url: `${_paths.directories.handlers.root}BCP/Servers/Import/getImportDetails.ashx`,
    //   method: 'GET',
    //   params: {
    //     serverImportSetId: serverImportSetId,
    //   },
    // });
  }

  stageServerImportData(/* customerId, assessmentId, bankName, fileName, uploadType */) {
    // return this.$http.post(
    //   `${_paths.directories.handlers.root}BCP/Servers/Import/stageImportData.ashx`,
    //   {},
    //   {
    //     params: {
    //       customerId: customerId,
    //       assessmentId: assessmentId,
    //       bankName: bankName,
    //       fileName: fileName,
    //       uploadType: uploadType,
    //     },
    //   }
    // );
  }

  processServerImportData(/* assessmentId, serverImportSetId */) {
    // return this.$http.post(
    //   `${_paths.directories.handlers.root}BCP/Servers/Import/processImport.ashx`,
    //   {},
    //   {
    //     params: {
    //       assessmentId: assessmentId,
    //       serverImportSetId: serverImportSetId,
    //     },
    //   }
    // );
  }

  // ///////////// Assessment Documents ////////////////////

  getAssessmentDocument(id) {
    console.log('getAssessmentDocument');
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentDocument/${id}`,
      method: 'GET',
      params: {},
    });
  }

  getAssessmentDocumentsByFolder(folderId) {
    console.log('getAssessmentDocumentsByFolder');
    return this.$http({
      url: `${this.apiRootUrl}/bcp/folder/${folderId}/assessmentDocument`,
      method: 'GET',
      params: {},
    });
  }

  getAssessmentDocumentsByAssessment(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/assessmentDocument`,
      method: 'GET',
      params: {},
    });
  }

  attachAssessmentDocument(assessmentId, documentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentDocument`,
      method: 'POST',
      data: this.serializeData({
        assessmentId,
        documentId,
      }),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  detachAssessmentDocument(assessmentDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentDocument/${assessmentDocumentId}`,
      method: 'DELETE',
      params: {},
    });
  }

  deleteDocumentAttachment(documentAttachmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/policyDocumentAttachment/${documentAttachmentId}`,
      method: 'DELETE',
    });
  }

  deleteDocumentSupportingDocument(documentSupportingDocumentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/policyDocumentSupportingDocument/${documentSupportingDocumentId}`,
      method: 'DELETE',
    });
  }

  uploadAssessmentDocument(assessmentId, assessmentDocument) {
    return _upload.upload({
      url: `${this.apiRootUrl}/bcp/assessment/${assessmentId}/document/upload`,
      data: {
        assessmentId,
        assessmentDocumentId: assessmentDocument.bcpAssessmentDocumentId,
        displayValue: assessmentDocument.name,
        isDeletable: assessmentDocument.deletable,
        file: assessmentDocument.file,
      },
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
    });
  }

  updateAssessmentDocument(assessmentDocument) {
    /* eslint-disable */
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentDocument/${assessmentDocument.bcpAssessmentDocumentId}`,
      method: 'PUT',
      data: JSON.stringify(assessmentDocument),
      params: {
        echo: true,
      },
      headers: { 'Content-Type': 'application/json' },
    });
  }

  downloadAllAssessmentDocuments(assessmentId) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentDocument/downloadAll/${assessmentId}`,
      method: 'GET',
      responseType: 'arraybuffer',
    });
  }

  checkAttachedDocumentDisplayNameExists(assessmentId, assessmentDocumentId, displayName) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentDocument/checkDisplayNameExists/`,
      method: 'GET',
      params: {
        assessmentId,
        assessmentDocumentId,
        displayName,
      },
    });
  }

  checkAttachedDocumentFileNameExists(assessmentId, assessmentDocumentId, fileName) {
    return this.$http({
      url: `${this.apiRootUrl}/bcp/assessmentDocument/checkFileNameExists/`,
      method: 'GET',
      params: {
        assessmentId,
        assessmentDocumentId,
        fileName,
      },
    });
  }
}

bcpDataService.$inject = ['$http', 'Upload', 'utilityService'];

export default angular.module('app.services.bcpDataService', [ngFileUpload]).service('bcpDataService', bcpDataService)
  .name;
